import { render, staticRenderFns } from "./ServiceDetailsCard.vue?vue&type=template&id=d9c202a2"
import script from "./ServiceDetailsCard.vue?vue&type=script&lang=js"
export * from "./ServiceDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports